import React from "react";

const TapNTailgateLogo = () => {
  return (
    <svg id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70">
      <defs>
        <style>{`.b{fill:#fff;}.c{fill:#ffc72c;}.d{fill:#12284a;}`}</style>
      </defs>
      <g>
        <circle className="d" cx="35" cy="35" r="34.3" />
        <path
          className="c"
          d="M35,1.4c18.53,0,33.6,15.07,33.6,33.6s-15.07,33.6-33.6,33.6S1.4,53.53,1.4,35,16.47,1.4,35,1.4M35,0C15.67,0,0,15.67,0,35s15.67,35,35,35,35-15.67,35-35S54.33,0,35,0h0Z"
        />
      </g>
      <path
        className="b"
        d="M12.86,49.94l-.75-1.33-2.99,1.68-.71-1.27,2.99-1.68-.75-1.33,1.12-.63,2.21,3.92-1.12,.63h0Z"
      />
      <path
        className="b"
        d="M12.56,53.85l-1.2-1.52-.74,.25-.95-1.21,4.93-1.37,1.03,1.3-2.48,4.48-1-1.27,.41-.66h0Zm.56-.91l.94-1.5-1.68,.56,.75,.94Z"
      />
      <path
        className="b"
        d="M16.91,52.82l2.56,2.17c.65,.55,.7,1.06,.14,1.73l-.59,.7c-.56,.67-1.08,.7-1.73,.14l-1.45-1.23-.88,1.03-1.11-.94,3.05-3.6h0Zm.61,3.55c.21,.18,.34,.17,.52-.04l.28-.34c.18-.21,.17-.34-.04-.52l-1-.85-.76,.9,1,.85Z"
      />
      <path
        className="b"
        d="M22.87,58.42l.46,.24-.64,1.21-1.41-.74,.24-.45c.18-.34,.34-.55,.68-.79l.82-.61,.74,.4-.9,.74h.01Z"
      />
      <path
        className="b"
        d="M28.79,59.63l-1.59,4.45-1.11-.4-1.26-3.26-.89,2.5-1.32-.47,1.59-4.45,1.16,.41,1.22,3.17,.87-2.43,1.32,.47h0Z"
      />
      <path
        className="b"
        d="M35.29,61.66l-1.52-.11-.25,3.42-1.45-.1,.25-3.42-1.52-.11,.09-1.28,4.48,.32-.09,1.28h0Z"
      />
      <path
        className="b"
        d="M38.39,64.09l-1.93,.16-.2,.76-1.53,.13,1.59-4.87,1.65-.13,2.35,4.54-1.6,.13-.32-.71Zm-.45-.97l-.73-1.62-.47,1.71,1.21-.1Z"
      />
      <path
        className="b"
        d="M41.51,59.45l1.07,4.59-1.44,.34-1.07-4.59,1.44-.34Z"
      />
      <path
        className="b"
        d="M46.82,61.26l.44,1.21-3.57,1.31-1.62-4.43,1.37-.5,1.18,3.22,2.2-.81Z"
      />
      <path
        className="b"
        d="M46.4,59.21c-.47-.81-.31-1.39,.48-1.86l1.89-1.12c.79-.46,1.39-.32,1.86,.48l.17,.3-1.25,.74-.05-.09c-.16-.28-.31-.31-.59-.15l-.99,.58c-.28,.16-.31,.31-.15,.59l.81,1.37c.16,.27,.31,.31,.59,.15l1.03-.61c.28-.16,.31-.31,.15-.59l-.09-.16-.91,.53-.48-.82,2.11-1.24,.66,1.12c.47,.81,.31,1.39-.48,1.86l-1.89,1.12c-.79,.46-1.38,.32-1.86-.48l-1.01-1.71h0Z"
      />
      <path
        className="b"
        d="M55.23,56.19l-1.44,1.29,.29,.73-1.15,1.03-1.66-4.84,1.23-1.1,4.62,2.2-1.2,1.07-.69-.37Zm-.94-.51l-1.56-.85,.66,1.65,.9-.8h0Z"
      />
      <path
        className="b"
        d="M57.05,50.05l-.97,1.18,2.65,2.17-.92,1.12-2.65-2.17-.97,1.18-1-.82,2.85-3.48,1,.82h0Z"
      />
      <path
        className="b"
        d="M61.27,47.22l1,.56-2.03,3.61-4.11-2.31,1.99-3.55,1,.56-1.28,2.28,.58,.32,1.15-2.04,.87,.49-1.15,2.04,.66,.37,1.31-2.34h.01Z"
      />
      <path
        className="b"
        d="M4.93,35.77l4.71-.25,.08,1.48-4.71,.25-.08-1.48Z"
      />
      <path
        className="b"
        d="M5.36,29.23l4.69,.5-.13,1.17-2.88,1.98,2.64,.28-.15,1.39-4.69-.5,.13-1.23,2.8-1.92-2.56-.28,.15-1.39Z"
      />
      <path
        className="b"
        d="M8.33,23.79l-.47,1.45,3.26,1.06-.45,1.39-3.26-1.06-.47,1.45-1.23-.4,1.4-4.28,1.23,.4h0Z"
      />
      <path
        className="b"
        d="M12.87,20.12l1,.56-2.01,3.62-4.12-2.3,1.98-3.56,1,.56-1.27,2.28,.58,.32,1.14-2.04,.87,.49-1.14,2.04,.66,.37,1.3-2.34h0Z"
      />
      <path
        className="b"
        d="M16.35,17.66l-1.77-.27-.52,.61,1.15,.99-.95,1.11-3.59-3.07,2.19-2.55c.55-.65,1.07-.7,1.73-.13l.49,.42c.56,.48,.67,.91,.35,1.43l1.94,.27-1.03,1.2h0Zm-3.08-.34l.85-1c.18-.21,.17-.34-.04-.52l-.28-.24c-.21-.18-.34-.17-.52,.04l-.85,1,.83,.71h0Z"
      />
      <path
        className="b"
        d="M16.84,14.92l1.12-.85,.12,.16c.13,.18,.23,.19,.41,.06l1.06-.81c.18-.13,.19-.24,.06-.41l-.1-.13c-.13-.18-.22-.17-.41-.06l-1.61,1.02c-.62,.39-1.04,.39-1.49-.2l-.38-.5c-.45-.59-.37-1.05,.2-1.49l1.98-1.51c.58-.44,1.04-.39,1.49,.2l.23,.31-1.12,.85-.08-.1c-.13-.18-.24-.19-.41-.06l-.94,.71c-.18,.14-.19,.24-.06,.41l.05,.07c.13,.18,.22,.17,.41,.06l1.61-1.02c.61-.39,1.04-.39,1.49,.2l.43,.58c.45,.59,.37,1.05-.2,1.49l-2.11,1.61c-.58,.44-1.04,.39-1.49-.2l-.28-.36h0Z"
      />
      <path
        className="b"
        d="M24.54,7.95l-1.37,.66,1.49,3.08-1.31,.63-1.49-3.08-1.37,.66-.56-1.16,4.05-1.95,.56,1.16h0Z"
      />
      <path
        className="b"
        d="M28.86,9.49l-1.86,.52-.05,.78-1.48,.41,.64-5.08,1.59-.44,3.17,4.01-1.55,.43-.45-.64h0Zm-.62-.88l-1.03-1.44-.13,1.77,1.16-.32h0Z"
      />
      <path
        className="b"
        d="M34.41,6.01l-1.51,.15,.33,3.41-1.44,.14-.33-3.41-1.51,.15-.13-1.28,4.48-.43,.13,1.28h0Z"
      />
      <path
        className="b"
        d="M39.62,8.67l-.1,1.15-4.12-.38,.43-4.69,4.05,.37-.1,1.15-2.6-.24-.06,.66,2.34,.22-.09,1-2.34-.22-.07,.75,2.67,.25h0Z"
      />
      <path
        className="b"
        d="M44.38,6.21l3.1,1.27c.79,.32,1,.79,.67,1.6l-.34,.85c-.33,.8-.81,1-1.59,.67l-1.76-.72-.51,1.24-1.35-.55,1.79-4.36Zm1.68,3.17c.25,.1,.37,.06,.47-.19l.17-.41c.1-.25,.06-.37-.19-.47l-1.21-.49-.44,1.09,1.21,.49h0Z"
      />
      <path
        className="b"
        d="M50.25,13.67l-1.61-1.07-.63,.46-1.28-.85,4.27-2.83,1.38,.91-.97,5.02-1.34-.89,.19-.76Zm.25-1.04l.43-1.72-1.43,1.06,1,.67Z"
      />
      <path
        className="b"
        d="M53.95,18.01l.44-1.73-.56-.58-1.09,1.05-1-1.05,3.41-3.26,2.32,2.43c.59,.62,.59,1.13-.04,1.74l-.46,.44c-.53,.51-.97,.57-1.46,.21l-.46,1.91-1.09-1.14h0Zm.64-3.04l.91,.94c.19,.2,.31,.2,.52,0l.26-.25c.2-.19,.2-.31,0-.52l-.91-.94-.79,.76h0Z"
      />
      <path
        className="b"
        d="M57.07,22.34l1.03-2.64-1.92,1.18-.76-1.24,4.02-2.46,.76,1.24-1.83,1.12,2.71,.31,.96,1.57-2.97-.5-1.04,2.99-.96-1.57h.01Z"
      />
      <path
        className="b"
        d="M63.12,24.15l-4.36,1.79-.56-1.37,4.36-1.79,.56,1.37Z"
      />
      <path
        className="b"
        d="M64.86,30.5l-4.6,1.06-.26-1.15,2.08-2.82-2.59,.59-.31-1.36,4.6-1.06,.28,1.21-2.02,2.74,2.52-.58,.31,1.37h0Z"
      />
      <path
        className="b"
        d="M63.68,32.28c.94-.01,1.37,.41,1.39,1.34l.04,2.2c.01,.92-.4,1.37-1.34,1.39h-.34l-.02-1.45h.1c.32,0,.43-.12,.43-.44l-.02-1.15c0-.32-.11-.43-.44-.43l-1.59,.03c-.31,0-.43,.11-.43,.44l.02,1.2c0,.32,.12,.43,.44,.43h.18v-1.06h.94l.04,2.44-1.3,.02c-.94,.01-1.37-.41-1.39-1.34l-.04-2.2c-.01-.92,.4-1.37,1.34-1.39l2-.03h-.01Z"
      />
      <path
        className="b"
        d="M8.05,43.4c.97,0,1.75-.78,1.75-1.75s-.78-1.75-1.75-1.75-1.75,.78-1.75,1.75,.78,1.75,1.75,1.75Z"
      />
      <path
        className="b"
        d="M61.95,43.4c.97,0,1.75-.78,1.75-1.75s-.78-1.75-1.75-1.75-1.75,.78-1.75,1.75,.78,1.75,1.75,1.75Z"
      />
      <path
        className="b"
        d="M19.56,19.55h0c4.28-4.29,9.39-6.41,15.45-6.41s11.18,2.12,15.46,6.41c4.27,4.28,6.39,9.41,6.39,15.47s-2.11,11.18-6.39,15.45c-4.28,4.27-9.42,6.39-15.46,6.39s-11.17-2.12-15.45-6.39h0c-4.29-4.28-6.41-9.4-6.41-15.45s2.12-11.18,6.41-15.46Z"
      />
      <path
        className="c"
        d="M46.9,46.76l1.56-.9c.24-.14,.32-.44,.18-.68-.14-.24-.45-.32-.68-.18l-1.56,.9c-.32-.57-.61-1.16-.88-1.76l1.67-.69c.25-.11,.38-.4,.27-.65-.11-.26-.4-.38-.65-.27l-1.68,.7c-.24-.61-.44-1.23-.62-1.86l1.75-.47c.27-.07,.43-.35,.35-.61-.07-.27-.35-.42-.61-.35l-1.74,.46c-.15-.63-.27-1.27-.36-1.93l1.76-.23c.27-.04,.47-.29,.43-.56-.04-.28-.29-.47-.56-.43l-1.76,.23c-.06-.64-.1-1.29-.11-1.96h1.76c.28,0,.5-.22,.5-.5s-.22-.5-.5-.5h-1.76c.01-.66,.05-1.31,.11-1.95l1.76,.23s.04,0,.07,0c.25,0,.46-.18,.5-.43,.04-.27-.16-.53-.43-.56l-1.76-.23c.09-.65,.22-1.29,.37-1.93l1.73,.46s.09,.02,.13,.02c.22,0,.42-.15,.48-.37,.07-.27-.09-.54-.35-.61l-1.74-.47c.18-.63,.39-1.25,.62-1.86l1.68,.69c.06,.03,.13,.04,.19,.04,.2,0,.38-.12,.46-.31,.11-.25-.02-.55-.27-.65l-1.67-.69c.27-.6,.56-1.18,.88-1.76l1.55,.9c.08,.05,.17,.07,.25,.07,.17,0,.34-.09,.43-.25,.14-.24,.06-.54-.18-.68l-1.55-.89c.64-1.03,1.36-2.03,2.19-2.98l.49-.55-.55-.5c-3.96-3.59-8.56-5.34-14.04-5.34s-10.07,1.75-14.04,5.34l-.54,.49,.48,.55c.84,.96,1.57,1.97,2.22,3.02l-1.46,.85c-.24,.14-.32,.44-.18,.68,.09,.16,.26,.25,.43,.25,.08,0,.17-.02,.25-.07l1.46-.84c.32,.57,.6,1.15,.87,1.75l-1.56,.65c-.25,.11-.38,.4-.27,.65,.08,.19,.27,.31,.46,.31,.06,0,.13-.01,.19-.04l1.57-.65c.23,.61,.44,1.22,.61,1.85l-1.63,.44c-.27,.07-.42,.35-.35,.61,.06,.22,.26,.37,.48,.37,.04,0,.09,0,.13-.02l1.61-.43c.15,.63,.27,1.26,.36,1.91l-1.63,.21c-.27,.04-.47,.29-.43,.56,.03,.25,.25,.43,.5,.43,.02,0,.04,0,.07,0l1.63-.21c.06,.64,.1,1.28,.11,1.94h-1.62c-.28,0-.5,.22-.5,.5s.22,.5,.5,.5h1.63c-.01,.66-.05,1.3-.11,1.94l-1.63-.21c-.27-.04-.53,.16-.56,.43-.04,.27,.16,.53,.43,.56l1.63,.22c-.09,.65-.21,1.28-.36,1.91l-1.61-.43c-.27-.06-.54,.09-.61,.35-.07,.27,.09,.54,.35,.61l1.63,.44c-.18,.63-.38,1.24-.61,1.85l-1.57-.65c-.25-.11-.55,.01-.65,.27-.11,.25,.02,.55,.27,.65l1.57,.65c-.26,.59-.55,1.18-.87,1.75l-1.46-.85c-.24-.14-.55-.06-.68,.18-.14,.24-.06,.54,.18,.68l1.47,.85c-.65,1.05-1.38,2.06-2.22,3.03l-.48,.55,.55,.49c3.97,3.58,8.56,5.32,14.03,5.32s10.06-1.74,14.03-5.32l.55-.49-.49-.56c-.83-.95-1.55-1.94-2.19-2.97Zm-11.9,7.85c-4.84,0-8.93-1.46-12.48-4.46,.71-.86,1.33-1.77,1.9-2.69l1.57,.91c.08,.05,.17,.07,.25,.07,.17,0,.34-.09,.43-.25,.14-.24,.06-.54-.18-.68l-1.55-.9c.35-.63,.66-1.27,.95-1.93l1.66,.69c.06,.03,.13,.04,.19,.04,.2,0,.38-.12,.46-.31,.11-.25-.02-.55-.27-.65l-1.67-.69c.26-.67,.48-1.34,.68-2.04l1.75,.47s.09,.02,.13,.02c.22,0,.42-.15,.48-.37,.07-.27-.09-.54-.35-.61l-1.76-.47c.16-.69,.29-1.39,.39-2.1l1.83,.24s.04,0,.07,0c.25,0,.46-.18,.5-.43,.04-.27-.16-.53-.43-.56l-1.84-.24c.07-.7,.11-1.41,.13-2.13h1.87c.28,0,.5-.22,.5-.5s-.22-.5-.5-.5h-1.87c-.01-.72-.06-1.43-.13-2.13l1.85-.24c.27-.04,.47-.29,.43-.56-.04-.28-.29-.47-.56-.43l-1.84,.24c-.1-.71-.23-1.41-.39-2.1l1.76-.47c.27-.07,.42-.35,.35-.61-.07-.27-.34-.42-.61-.35l-1.76,.47c-.19-.69-.42-1.37-.68-2.03l1.67-.69c.25-.11,.38-.4,.27-.65-.11-.25-.4-.38-.65-.27l-1.66,.69c-.29-.65-.6-1.3-.95-1.93l1.56-.9c.24-.14,.32-.44,.18-.68-.14-.24-.44-.32-.68-.18l-1.57,.91c-.57-.93-1.19-1.83-1.9-2.69,3.55-3.01,7.64-4.48,12.48-4.48s8.94,1.46,12.49,4.47c-.7,.85-1.31,1.74-1.87,2.64l-1.49-.86c-.24-.14-.54-.06-.68,.18-.14,.24-.06,.54,.18,.68l1.46,.85c-.35,.63-.67,1.28-.96,1.94l-1.55-.64c-.25-.11-.55,.01-.65,.27-.11,.25,.02,.55,.27,.65l1.56,.65c-.26,.67-.49,1.35-.69,2.05l-1.64-.44c-.26-.06-.54,.09-.61,.35-.07,.27,.09,.54,.35,.61l1.64,.44c-.16,.69-.3,1.4-.4,2.12l-1.71-.22c-.27-.04-.53,.16-.56,.43-.04,.27,.16,.53,.43,.56l1.72,.23c-.07,.71-.12,1.42-.13,2.15h-1.74c-.28,0-.5,.22-.5,.5s.22,.5,.5,.5h1.74c.01,.73,.06,1.44,.13,2.15l-1.71,.23c-.27,.04-.47,.29-.43,.56,.03,.25,.25,.43,.5,.43,.02,0,.04,0,.07,0l1.7-.22c.1,.72,.23,1.43,.4,2.12l-1.64,.44c-.27,.07-.43,.35-.35,.61,.06,.22,.26,.37,.48,.37,.04,0,.09,0,.13-.02l1.63-.44c.2,.7,.43,1.38,.69,2.05l-1.56,.65c-.25,.11-.38,.4-.27,.65,.08,.19,.27,.31,.46,.31,.06,0,.13-.01,.19-.04l1.55-.64c.29,.66,.61,1.3,.96,1.94l-1.46,.84c-.24,.14-.32,.44-.18,.68,.09,.16,.26,.25,.43,.25,.08,0,.17-.02,.25-.07l1.48-.86c.56,.91,1.17,1.79,1.87,2.64-3.56,3-7.65,4.46-12.48,4.46Z"
      />
      <path
        className="c"
        d="M35.01,16.15c5.26,0,9.62,1.81,13.33,5.52,3.71,3.72,5.51,8.08,5.51,13.35s-1.8,9.62-5.5,13.33c-3.72,3.71-8.08,5.51-13.34,5.51s-9.58-1.79-13.28-5.46l-.05-.05c-3.72-3.71-5.53-8.06-5.53-13.32s1.81-9.63,5.5-13.31l.02-.02,.02-.02c3.71-3.72,8.07-5.52,13.33-5.52m0-3c-6.06,0-11.17,2.12-15.45,6.41h0c-4.29,4.28-6.41,9.41-6.41,15.47s2.12,11.17,6.41,15.45h0c4.28,4.27,9.41,6.39,15.45,6.39s11.18-2.12,15.46-6.39c4.27-4.28,6.39-9.39,6.39-15.45s-2.11-11.18-6.39-15.47c-4.28-4.29-9.4-6.41-15.46-6.41h0Z"
      />
    </svg>
  );
};
export default TapNTailgateLogo;
